import src from "IMAGE";
export default { src, width: 173, height: 120, blurWidth: 0, blurHeight: 0};
